import GeRealtimeCompareTimeGroupNew from "./GeRealtimeCompareTimeGroupNew";

export default function RealtimeCompareTimeGroup() {
    return GeRealtimeCompareTimeGroupNew({
        menuCode: 'flowSummary'
    });
}
